interface AppRoute {
    ADMIN: {
        ROOT: string;
    };
    AUTH: {
        LOGIN: string;
        PROFILE: string;
        DELETE_ACCOUNT: string;
    };
    PROFILE: {
        ROOT: string;
        EDIT: string;
    };
    CUSTOMER: {
        ROOT: string;
        LIST: string;
        UNREGISTERED_CUSTOMERS: string;
        UNAUTHORIZED_SMARTPHONE_CUSTOMER: string;
        SMARTPHONE_CUSTOMER_DETAIL: string;
        DETAIL_REGISTER: string;
        DETAIL_UPDATE: string;
    };
    SALES_MANAGEMENT: {
        ROOT: string;
        REVENUE: string;
        DISCOUNT: string;
        CARD: string;
        DAILY_REPORT: string;
        TOTAL_OF_ALL_STORE: string;
        PRODUCT_REPORT: {
            ROOT: string;
            DAILY_REPORT: string;
            MONTHLY_REPORT: string;
        };
        SEAT_REPORT: {
            ROOT: string;
            MONTHLY_REPORT: string;
        };
        STORE_REPORT: {
            ROOT: string;
            LIST_OF_SALES: string;
            BULLETIN_OF_SBS: string;
        };
        STAFF: {
            ROOT: string;
            LIST_STAFF: string;
            REGISTER_STAFF: {
                ADD: string;
                EDIT: string;
            };
        };
        SEAT_USAGE_HISTORY: {
            ROOT: string;
        };
        SEAT_USAGE: {
            ROOT: string;
        };
    };
    PRICE_SEAT_MANAGEMENT: {
        ROOT: string;
        FEES_CLASSIFY_REGISTER: string;
        SEAT: {
            ROOT: string;
            LIST_CLOSE: string;
            REGISTER_CLOSE: string;
            UPDATE_CLOSE: string;
            LIST_TYPE: string;
            REGISTER_TYPE: string;
            UPDATE_TYPE: string;
        };
        ROOM: {
            ROOT: string;
            ADD: string;
            UPDATE: string;
        };
        FLOOR: {
            ROOT: string;
            ADD_FLOOR: string;
            LIST_FLOOR: string;
            UPDATE_FLOOR: string;
        };
        PRODUCT: {
            ROOT: string;
            PRODUCT_LIST: string;
            ADD_PRODUCT: string;
            DOWNLOAD_CSV: string;
        };
        PRODUCT_PRICE: {
            ROOT: string;
            LIST: string;
            UPDATE_PRICE: string;
            SORT_ORDER: string;
        };
        CATEGORY: {
            ROOT: string;
            LIST: string;
            REGISTER: string;
            UPDATE: string;
            SORT_ORDER: string;
        };
        PLAN: {
            ROOT: string;
            LIST: string;
            REGISTER: string;
        };
        PRODUCT_PLAN: {
            ROOT: string;
            LIST: string;
            REGISTER: string;
        };
        DEVICE: {
            ROOT: string;
            LIST: string;
            REGISTER: string;
            UPDATE: string;
            EQUIPMENT: {
                ROOT: string;
                REGISTER: string;
            };
            CUSTOMER_TYPE_REGISTER?: string;
            BUSINESS_DAY: {
                ROOT: string;
                REGISTER: string;
            };
        };
        HISTORY_MANAGEMENT: {
            ROOT: string;
            HISTORY_MONTHLY: string;
            EDIT_HISTORY_BY_MONTH: string;
            SLIP_EDIT_HISTORY: string;
            SLIP_EDIT_HISTORY_DETAIL: string;
            SALES_EDIT_HISTORY: string;
            PRICE_EDIT_HISTORY: string;
            CURRENT_EXCHANGE: string;
            STOCK_HISTORY: string;
        };
    };
    MASTER_MANAGEMENT: {
        ROOT: string;
        DISCOUNT: {
            ROOT: string;
            REGISTER: string;
            LIST: string;
            UPDATE: string;
        };
        STORE_ACCESS: {
            ROOT: string;
            LIST: string;
            REGISTER: string;
            UPDATE: string;
        };
        USER: {
            ROOT: string;
            REGISTER: string;
            LIST: string;
        };
        SETTING_STORE: {
            ROOT: string;
            PRINT_SETTING: string;
            AUTHENTICATE_SETTING: string;
        };
        PRINTER: {
            LIST: string;
            REGISTER_PRINTER: string;
        };
        STAFF: {
            ROOT: string;
            LIST_STAFF: string;
            REGISTER: string;
            UPDATE: string;
            REGISTER_STAFF: {
                ADD: string;
                EDIT: string;
            };
        };
        CARD: {
            ROOT: string;
            REGISTER: string;
            EDIT: string;
            LIST: string;
        };
        REGISTER_RECEIPT: string;
        NOT_FOUND: string;
        OUT_TIME_BUNDLE: string;
    };

    WORK_MANAGE: {
        ROOT: string;
        ADD: string;
        UPDATE: string;
        LIST: string;
        REVIEW: string;
    };

    REMOTE_MANAGEMENT: {
        ROOT: string;
        SETTING: string;
        DASHBOARD: string;
    };
    APP_MANAGEMENT: {
        ROOT: string;
        HISTORY_ISSUED_STAMPS: string;
        COUPON: {
            ROOT: string;
            NORMAL: string;
            INSTALL: string;
            RANK: string;
            HISTORY: string;
        };
        MEMBER_SEARCH: string;
        APP_HISTORY: {
            ROOT: string;
        };
        SETTING_BANNER: string;
        TICKET: {
            ROOT: string;
            ADD: string;
            UPDATE: string;
        };
        MESSAGE: string;
        ISSUED_TICKET: string;
        USE_TICKET: {
            USE: string;
            HISTORY: string;
        };
        APP_DOWNLOADS: string;
    };
}

export const appRoutes: AppRoute = {
    ADMIN: {
        ROOT: '',
    },
    AUTH: {
        LOGIN: 'login',
        PROFILE: 'profile',
        DELETE_ACCOUNT: 'delete-account',
    },
    PROFILE: {
        ROOT: 'profile',
        EDIT: 'profile/edit',
    },
    CUSTOMER: {
        ROOT: 'customer',
        LIST: 'customer/list',
        UNREGISTERED_CUSTOMERS: 'customer/unregistered-customers',
        UNAUTHORIZED_SMARTPHONE_CUSTOMER: 'customer/unauthorized-smartphone-customer',
        SMARTPHONE_CUSTOMER_DETAIL: 'customer/:customerId/smartphone-customer-detail',
        DETAIL_REGISTER: 'customer/:customerCardId/register',
        DETAIL_UPDATE: 'customer/:customerId/update',
    },
    SALES_MANAGEMENT: {
        ROOT: 'sales-management',
        REVENUE: 'sales-management/revenue',
        DISCOUNT: 'sales-management/discount',
        CARD: 'sales-management/card',
        DAILY_REPORT: 'sales-management/daily-report',
        TOTAL_OF_ALL_STORE: 'sales-management/total-of-all-store',
        PRODUCT_REPORT: {
            ROOT: 'sales-management/product-report',
            DAILY_REPORT: 'sales-management/product-report/daily',
            MONTHLY_REPORT: 'sales-management/product-report/monthly',
        },
        STORE_REPORT: {
            ROOT: 'sales-management/store-report',
            LIST_OF_SALES: 'sales-management/store-report/list-of-sales',
            BULLETIN_OF_SBS: 'sales-management/store-report/bulletin-of-sbs',
        },
        STAFF: {
            ROOT: 'sales-total/staff',
            LIST_STAFF: 'sales-total/staff/list',
            REGISTER_STAFF: {
                ADD: 'sales-total/staff-register/add',
                EDIT: 'string;',
            },
        },
        SEAT_REPORT: {
            ROOT: 'sales-management/seat-report',
            MONTHLY_REPORT: 'sales-management/seat-report/monthly',
        },
        SEAT_USAGE_HISTORY: {
            ROOT: 'sales-management/seat-usage-history',
        },
        SEAT_USAGE: {
            ROOT: 'sales-total/seat-usage',
        },
    },
    PRICE_SEAT_MANAGEMENT: {
        ROOT: 'price-seat-management',
        FEES_CLASSIFY_REGISTER: 'price-seat-management/fees-classify-register',
        SEAT: {
            ROOT: 'price-seat-management/seat',
            LIST_CLOSE: 'price-seat-management/seat/list-close',
            REGISTER_CLOSE: 'price-seat-management/seat/register-close',
            UPDATE_CLOSE: 'price-seat-management/seat/update-close',
            LIST_TYPE: 'price-seat-management/seat/list-type',
            REGISTER_TYPE: 'price-seat-management/seat/register-type',
            UPDATE_TYPE: 'price-seat-management/seat/update-type',
        },
        ROOM: {
            ROOT: 'price-seat-management/room',
            ADD: 'price-seat-management/room/add',
            UPDATE: 'price-seat-management/room/update/:id',
        },
        FLOOR: {
            ROOT: 'price-seat-management/floor',
            ADD_FLOOR: 'price-seat-management/floor/register',
            LIST_FLOOR: 'price-seat-management/floor/list',
            UPDATE_FLOOR: 'price-seat-management/floor/update',
        },
        PRODUCT: {
            ROOT: 'price-seat-management/product-register',
            PRODUCT_LIST: 'price-seat-management/product-register/list',
            ADD_PRODUCT: 'price-seat-management/product-register/add-product',
            DOWNLOAD_CSV: 'price-seat-management/product-register/download',
        },
        PRODUCT_PRICE: {
            ROOT: 'price-seat-management/product-price',
            LIST: 'price-seat-management/product-price/list',
            UPDATE_PRICE: 'price-seat-management/product-price/update-price',
            SORT_ORDER: 'price-seat-management/product-price/sort-order',
        },
        CATEGORY: {
            ROOT: 'price-seat-management/category',
            LIST: 'price-seat-management/category/list',
            REGISTER: 'price-seat-management/category/register',
            UPDATE: 'price-seat-management/category/update',
            SORT_ORDER: 'price-seat-management/category/sort-order',
        },
        PLAN: {
            ROOT: 'price-seat-management/plan',
            LIST: 'price-seat-management/plan/list',
            REGISTER: 'price-seat-management/plan/register',
        },
        PRODUCT_PLAN: {
            ROOT: 'price-seat-management/product-plan',
            LIST: 'price-seat-management/product-plan-list',
            REGISTER: 'price-seat-management/product-plan/register',
        },
        DEVICE: {
            ROOT: 'price-seat-management/device',
            LIST: 'price-seat-management/device/list',
            REGISTER: 'price-seat-management/device/register',
            UPDATE: 'price-seat-management/device/update',
            EQUIPMENT: {
                ROOT: 'price-seat-management/equipment',
                REGISTER: 'price-seat-management/equipment/register',
            },
            CUSTOMER_TYPE_REGISTER: 'price-seat-management/customer-type/register',
            BUSINESS_DAY: {
                ROOT: 'price-seat-management/business-day',
                REGISTER: 'price-seat-management/business-day/register',
            },
        },
        HISTORY_MANAGEMENT: {
            ROOT: 'history-management',
            HISTORY_MONTHLY: 'history-management/history/monthly',
            EDIT_HISTORY_BY_MONTH: 'history-management/history/edit-history',
            SLIP_EDIT_HISTORY: 'history-management/history/slip-edit-history',
            SLIP_EDIT_HISTORY_DETAIL: 'history-management/history/slip-edit-history-detail',
            PRICE_EDIT_HISTORY: 'history-management/history/price-edit-history',
            SALES_EDIT_HISTORY: 'history-management/history/sales-edit-history',
            CURRENT_EXCHANGE: 'history-management/history/current-exchange',
            STOCK_HISTORY: 'history-management/history/stock-history',
        },
    },
    MASTER_MANAGEMENT: {
        ROOT: 'master-management',
        DISCOUNT: {
            ROOT: 'master-management/discount',
            REGISTER: 'master-management/discount/register',
            LIST: 'master-management/discount/list',
            UPDATE: 'master-management/discount/update',
        },
        STORE_ACCESS: {
            ROOT: 'master-management/store-access',
            LIST: 'master-management/store-access/list',
            REGISTER: 'master-management/store-access/register',
            UPDATE: 'master-management/store-access/update',
        },
        USER: {
            ROOT: 'master-management/user',
            REGISTER: 'master-management/user/register',
            LIST: 'master-management/user/list',
        },
        CARD: {
            ROOT: 'master-management/card',
            REGISTER: 'master-management/card/register',
            EDIT: 'master-management/card/:id/edit',
            LIST: 'master-management/card/list',
        },
        SETTING_STORE: {
            ROOT: 'master-management/setting-store',
            PRINT_SETTING: 'master-management/print-setting',
            AUTHENTICATE_SETTING: 'master-management/authenticate-setting',
        },
        PRINTER: {
            LIST: 'master-management/printer',
            REGISTER_PRINTER: 'master-management/printer',
        },
        STAFF: {
            ROOT: 'master-management/staff',
            LIST_STAFF: 'master-management/staff/list',
            REGISTER: 'master-management/staff/register',
            UPDATE: 'master-management/staff/update',
            REGISTER_STAFF: {
                ADD: 'master-management/staff-register/add',
                EDIT: 'string;',
            },
        },
        REGISTER_RECEIPT: 'master-management/register-receipt',

        NOT_FOUND: '404',
        OUT_TIME_BUNDLE: 'master-management/out-time-bundle',
    },
    WORK_MANAGE: {
        ROOT: 'work-manage',
        ADD: 'work-manage/add',
        UPDATE: 'work-manage/update',
        LIST: 'work-manage/list',
        REVIEW: 'work-manage/review',
    },
    REMOTE_MANAGEMENT: {
        ROOT: 'remote-management',
        SETTING: 'remote-management/setting',
        DASHBOARD: 'remote-management/dashboard',
    },
    APP_MANAGEMENT: {
        ROOT: 'app-management',
        HISTORY_ISSUED_STAMPS: 'app-management/stamp/history',
        COUPON: {
            ROOT: 'app-management/coupon',
            NORMAL: 'app-management/coupon/normal',
            INSTALL: 'app-management/coupon/install',
            RANK: 'app-management/coupon/rank',
            HISTORY: 'app-management/coupon/history',
        },
        MEMBER_SEARCH: 'app-function/member-search',
        APP_HISTORY: {
            ROOT: 'app-function/:id',
        },
        SETTING_BANNER: 'app-function/setting-banner',
        TICKET: {
            ROOT: 'app-management/ticket',
            ADD: 'app-management/ticket/add',
            UPDATE: 'app-management/ticket/update',
        },
        MESSAGE: 'app-management/message',
        ISSUED_TICKET: 'app-management/ticket/issued',
        USE_TICKET: {
            USE: 'app-management/ticket/use',
            HISTORY: 'app-management/ticket/use/history',
        },
        APP_DOWNLOADS: 'app-management/app-downloads',
    },
};
